import _ from 'lodash';


const StavkaNaloga = function(DS) {
    return DS.defineResource({
        name: 'StavkaNaloga',
        endpoint: '/stavkeNaloga',
         methods: {
            group: function (stavke) {
                let groupedStavke = [];
                stavke.map((stavka) => {
                    let item = _.find(groupedStavke, {protetski_rad: stavka.protetski_rad, cjenik: stavka.cjenik});
                    if (_.isUndefined(item)) {
                        item = {
                            protetski_rad: stavka.protetski_rad,
                            cjenik: stavka.cjenik,
                            pozicije: [stavka.pozicija]
                        };
                        groupedStavke.push(item);
                        return;
                    }
                    item.pozicije.push(stavka.pozicija);
                });
                return groupedStavke;
            }
        }
    });
};

StavkaNaloga.$inject = ['DS'];

export {StavkaNaloga};



// WEBPACK FOOTER //
// ./app/models/stavkaNaloga.js